
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/select-student",
      function () {
        return require("private-next-pages/user/select-student.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/select-student"])
      });
    }
  